var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"imgimportswap"},_vm._l((_vm.sortData()),function(p){return _c('img',{key:p.id,staticClass:"mainimportimage",attrs:{"src":p.srcImg,"id":p.id,"ordby":p.orderBy}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }